// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6992 ? "be74e82d" : chunkId) + "." + {"6992":"625162a5149d018f","8162":"808ab35df02a2f3d"}[chunkId] + ".js";
};